/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'ptc.pm.collaborators.title': 'Vos collaborateurs',
  'ptc.pm.error-heading': "Un problème s'est produit",
  'ptc.pm.error-image-alt-text': 'Un robot cassé et un certain nombre de personnes affairées à le réparer.',
  'ptc.pm.error-text':
    "Nous gardons un œil sur ces erreurs, mais n'hésitez pas à nous contacter si l'actualisation de la page ne résout pas le problème.",
  'ptc.pm.num-members': '{memberCount, plural, one {{memberCount,number} membre} other {{memberCount,number} membres}}',
  'ptc.pm.people': 'Personnes',
  'ptc.pm.teams': 'Équipes',
  'ptc.pm.view-your-profile': 'Afficher votre profil',
  'ptc.pm.your-teams.title': 'Vos équipes',
};
